import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

const ProjectsCaraousel = ({ Projects }) => {
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 4,
    },
    desktop: {
      breakpoint: { max: 4000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  return (
    <Carousel responsive={responsive} infinite>
      {Projects.map((project, index) => {
        return (
          <div
            key={index}
            onClick={() => window.open(project.url, "_blank")}
            className="cursor-pointer my-2 md:my-5 md:mx-4 p-4 md:hover:scale-110  h-fit w-fit transform transition duration-300 bg-gray-900 rounded-lg"
          >
            <img
              src={project.img}
              alt={`Project ${index + 1}`}
              className=" mx-auto h-full"
            />
            <h3 className="text-lg md:text-2xl my-1 md:my-2 font-semibold">
              {project.projectName}
            </h3>
            <p className="text-xs md:text-base">{project.description}</p>
          </div>
        );
      })}
    </Carousel>
  );
};

export default function Projects() {
  const projects = [
    {
      projectName: "IMDB Clone",
      description:
        "A clone of the IMDB website to search for movies and TV shows.",
      url: "https://movie-clone-ebon.vercel.app/",
      img: require("../assets/images/projects/imdb-clone.jpeg"),
    },
    {
      projectName: "Bookstacks",
      description:
        "A full stack MERN website to search for books, and manage your books collection.",
      url: "https://bookstacks-z8zj.onrender.com/",
      img: require("../assets/images/projects/bookstacks.jpeg"),
    },
    {
      projectName: "Fly Detector",
      description:
        "A website to detect the faults in the aircrafts using machine learning.",
      url: "https://fly-detector.onrender.com/",
      img: require("../assets/images/projects/fly-detector.jpeg"),
    },
  ];

  return (
    <div id="projects" className="px-10 md:px-20 pt-5 md:pt-10">
      <h2 className="text-2xl md:text-4xl font-bold text-center mb-5 md:mb-10">
        My <span className="text-secondary"> Projects</span>
      </h2>
      <div className="my-5 md:my-10">
        <ProjectsCaraousel Projects={projects} />
      </div>
    </div>
  );
}
